"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Response_1 = __importDefault(require("../../Domain/Response"));
class Jest {
    constructor(expectation) {
        var _a, _b, _c;
        const defaultImplementation = jest.fn().mockResolvedValue(new Response_1.default(200, {}));
        this.get = (_a = expectation === null || expectation === void 0 ? void 0 : expectation.get) !== null && _a !== void 0 ? _a : defaultImplementation;
        this.post = (_b = expectation === null || expectation === void 0 ? void 0 : expectation.post) !== null && _b !== void 0 ? _b : defaultImplementation;
        this.delete = (_c = expectation === null || expectation === void 0 ? void 0 : expectation.delete) !== null && _c !== void 0 ? _c : defaultImplementation;
    }
}
exports.default = Jest;
